// We are taking the core library from react-csv to bypass their whacky way of saving but still using
// their csv conversion tools.

/* MIT License

Copyright (c) 2019 react-csv

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. */

// https://github.com/react-csv/react-csv/blob/master/src/core.js is the source file, I have stripped only
// array conversions

function isSafari() {
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

function isArray(data: string[][]) {
	return Array.isArray(data)
        && data.every(row => Array.isArray(row));
}

function joiner(data: string[][], separator: string, enclosingCharacter: string) {
	return data
		.filter(e => e)
		.map(row => row
			.map(column => {
				if (column.includes(separator) || column.includes('\n') || column.includes('\r')) {
					return `${enclosingCharacter}${column}${enclosingCharacter}`;
				}
				return column;
			})
			.join(separator))
		.join('\n');
}

function arrayToCsv(data: string[][], separator: string, enclosingCharacter: string) {
	return joiner(data, separator, enclosingCharacter);
}

// function that takes in the string array and serializes it into a csv string
export function toCsv(data: string[][], separator: string, enclosingCharacter: string) {
	if (isArray(data)) {
		return arrayToCsv(data, separator, enclosingCharacter);
	}

	console.error('data should be of the correct type');
	return '';
}

// function that takes in the string array and creates the blob object of the serialized csv string
export function buildBlob(data: string[][], seperator: string, enclosingCharacter: string) {
	const csv = toCsv(data, seperator, enclosingCharacter);
	const type = isSafari() ? 'application/csv' : 'text/csv';
	const blob = new Blob(['\uFEFF', csv], { type });

	return blob;
}
